module.exports = __webpack_public_path__ + "static/media/bienvenue3.c0d8001b.mp3";